<template>
<CContainer class="d-flex align-items-center min-vh-100">
  <CRow class="w-100 justify-content-center">
    <CCol md="6">
      <div class="w-100">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">Error</h1>
          <h3 class="pt-5">エラーが発生しました。</h3>
        </div>
        <p class="text-muted">ページにアクセスしようとした際にエラーが発生しました。</p>
        <p class="text-muted">お手数ですが、下記リンクより再度ログインしてください。</p>
        <router-link :to="{ name: 'Login' }">
          <CButton color="info">ログイン画面へ</CButton>
        </router-link>
      </div>
    </CCol>
  </CRow>
</CContainer>
</template>

<script>
export default {
  name: 'UserError'
}
</script>
